import React, { useState, useRef, useEffect } from "react";
import "./SchoolBusNavMenu.css";
import { NavLink, useLocation } from "react-router-dom";
import { Menu, Close } from "@mui/icons-material";
import DashboardIcon from "../../images/schoolTracking/navmenu/dashboard.svg";
import StudentIcon from "../../images/schoolTracking/navmenu/students.svg";
import DirectionsBusIcon from "../../images/schoolTracking/navmenu/vehcile.svg";
import PeopleIcon from "../../images/schoolTracking/navmenu/attendant.svg";
import RouteIcon from "../../images/schoolTracking/navmenu/routes.svg";
import LocationOnIcon from "../../images/schoolTracking/navmenu/stops.svg";
import PersonIcon from "../../images/schoolTracking/navmenu/driver.svg";
import ReportsIcon from "../../images/schoolTracking/navmenu/report.svg";
import SettingsIcon from "../../images/navbar/settings.svg";
import { useTranslation } from "react-i18next";

export default function SchoolBusNavMenu() {
  const { t } = useTranslation();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const timeoutRef = useRef(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const menuRef = useRef(null);

  const isActiveRoute = (path) => {
    return (
      location.pathname === path || location.pathname.startsWith(`${path}/`)
    );
  };

  const handleMouseEnter = (index) => {
    if (isMobileView) return;
    clearTimeout(timeoutRef.current);
    setHoveredItem(index);
  };

  const handleMouseLeave = () => {
    if (isMobileView) return;
    timeoutRef.current = setTimeout(() => {
      setHoveredItem(null);
    }, 300);
  };

  const toggleMobileMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleItemClick = (index) => {
    if (isMobileView) {
      setHoveredItem(hoveredItem === index ? null : index);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    if (isMobileView && isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMobileView, isMenuOpen]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobileView(mobile);
      if (!mobile && isMenuOpen) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [isMenuOpen]);

  // School Bus Menu Items
  const menuItems = [
    {
      label: "Dashboard",
      path: "/school",
      icon: DashboardIcon,
    },
    {
      label: "Students",
      path: "/school-students",
      icon: StudentIcon,
    },
    {
      label: "Vehicles",
      path: "/school-vehicles",
      icon: DirectionsBusIcon,
    },
    {
      label: "Attendants",
      path: "/school-attendants",
      icon: PeopleIcon,
    },
    {
      label: "Routes",
      path: "/school-routes",
      icon: RouteIcon,
    },
    {
      label: "Stops",
      path: "/school-stops",
      icon: LocationOnIcon,
    },
    {
      label: "Drivers",
      path: "/school-drivers",
      icon: PersonIcon,
    },
    {
      label: "Analytics",
      path: "/school-reports",
      icon: ReportsIcon,
    },
    {
      label: "Settings",
      path: "/school-settings",
      icon: SettingsIcon,
    },
  ];

  return (
    <div className="school-bus-nav-container" ref={menuRef}>
      {isMobileView && (
        <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          {isMenuOpen ? <Close /> : <Menu />}
        </div>
      )}

      <div
        className={`school-bus-nav-menu ${isMobileView ? "mobile" : ""} ${
          isMenuOpen ? "open" : ""
        }`}
      >
        {menuItems.map((item, index) => {
          const isActive = isActiveRoute(item.path);

          return (
            <div
              key={index}
              className="nav-item-wrapper"
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
              onClick={() => handleItemClick(index)}
            >
              <NavLink
                to={item.path}
                className={
                  isActive
                    ? "school-bus-sub-data active-link"
                    : "school-bus-sub-data"
                }
              >
                <span className="nav-icon">
                  <img
                    src={item.icon}
                    alt={t(item.label)}
                    style={{ width: "24px", height: "24px" }}
                  />
                </span>
                {!isMobileView && (hoveredItem === index || isActive) && (
                  <span className="nav-item-label">{t(item.label)}</span>
                )}
                {isMobileView && (
                  <span className="nav-item-label">{t(item.label)}</span>
                )}
              </NavLink>
            </div>
          );
        })}
      </div>
    </div>
  );
}
